export * from "./renderMiniOutrightDetails";